import React from 'react'
import { MessageOutlined, DeleteOutlined } from '@ant-design/icons'
import type { SkillKey, SkillCard, HistoryItem } from '../types'

interface SidebarProps {
  activeSkill: SkillKey
  activeHistory: string | null
  skillCards: SkillCard[]
  historyList: HistoryItem[]
  onSelectSkill: (skill: SkillKey) => void
  onSwitchHistory: (item: HistoryItem) => void
  onDeleteHistory: (e: React.MouseEvent, id: string) => void
}

export const Sidebar: React.FC<SidebarProps> = ({
  activeSkill,
  activeHistory,
  skillCards,
  historyList,
  onSelectSkill,
  onSwitchHistory,
  onDeleteHistory
}) => {
  return (
    <aside className="sidebar">
      <div className="logo-area">
        <span className="logo-icon"></span>
        <span>新小师</span>
      </div>

      {/* 技能列表 */}
      <div className="skill-section">
        <div className="section-title">技能</div>
        {skillCards.map(card => (
          <div
            key={card.key}
            className={`skill-item skill-${card.color} ${activeSkill === card.key ? 'active' : ''}`}
            onClick={() => onSelectSkill(card.key)}
          >
            {card.icon}
            <span>{card.title}</span>
          </div>
        ))}
      </div>

      {/* 最近会话 */}
      <div className="recent-title">最近会话</div>

      {historyList.length === 0 && (
        <div className="empty-history">暂无会话记录</div>
      )}

      {historyList.map(item => (
        <div
          key={item.id}
          className={`history-item ${activeHistory === item.id ? 'active' : ''}`}
          onClick={() => onSwitchHistory(item)}
        >
          <MessageOutlined />
          <span className="history-title">{item.title}</span>
          <button
            className="delete-btn"
            onClick={(e) => onDeleteHistory(e, item.id)}
            aria-label="删除会话"
          >
            <DeleteOutlined />
          </button>
        </div>
      ))}
    </aside>
  )
}
